import { Fab, FormControl, InputLabel, Select, MenuItem, TextField, FormControlLabel, Switch } from "@mui/material";
import styles from "../css/Catalogo.module.css";
import AddIcon from '@mui/icons-material/Add';
import { useEffect, useState } from "react";
import Items from "../components/Items";
import Item from "../components/Item";
import { useAuth } from "../hooks/AuthProvider";

import miAxios from "../api/axios";
import Wait from "../components/Wait";
import { Grid } from "@mui/system";

export default function Catalogo(props) {
    const [openItem, setOpenItem] = useState({
        open: false,
        id: 0
    })
    const [procesando, setProcesando] = useState(false)
    const [mensaje, setMensaje] = useState("")
    const [buscar, setBuscar] = useState("")
    const [categoria, setCategoria] = useState(0)
    const [incluyeInactivos, setIncluyeInactivos] = useState(false)
    const [rows, setRows] = useState([])
    const [rutaAzure, setRutaAzure] = useState("")
    const [rowsCategorias, setRowsCategorias] = useState([])

    const user = useAuth()
    const axios = miAxios(user.handleLogout)

    useEffect(() => {
        const procesosIniciales = async () => {
            await actRowsCategorias()
            await actRows()
        }
        procesosIniciales()

    }, [])

    useEffect(()=>{
        actRows()
    }, [categoria, incluyeInactivos])

    const actRowsCategorias = async () => {
        setProcesando(true)
        try {
            const response = await axios.get("listas/categorias-items")
            const data = response.data;
            if (data.respuesta == "S") {
                setRowsCategorias(data.datos)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const cerrarItem = () => {
        setOpenItem({
            ...openItem,
            open: false,
            id: 0
        })
        actRows()
    }

    const actRows = async () => {
        setProcesando(true)
        try {
            const response = await axios.get("items/catalogo-proveedores?categoria=" + categoria + "&incluye_inactivos=" + (incluyeInactivos ? "1" : "0"))

            const data = response.data;
            if (data.respuesta == "S") {
                setRows(data.lista)
                setRutaAzure(data.rutaAzure)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const handleEditItem = (cual) => {
        setOpenItem({
            ...openItem,
            open: true,
            id: cual
        })
    }

    return <div className={styles.cuerpo}>
        <Wait procesando={procesando} />
        <Items open={openItem.open} id={openItem.id} cerrar={cerrarItem} />

        <div className={styles.titulo}>
            Nuestro Catálogo
        </div>
        <div className={styles.filtro}>
            <div className={styles.add}>
                <Fab color="coopinfa" onClick={() => { setOpenItem({ open: true, id: 0 }) }} size="small">
                    <AddIcon />
                </Fab>
            </div>
            <Grid container spacing={2}>
                <Grid size={5}>
                    <TextField
                        color="coopinfa"
                        size="small"
                        fullWidth
                        label="Buscar..."
                        value={buscar}
                        onChange={(event) => { setBuscar(event.target.value) }}
                    />
                </Grid>
                <Grid size={5}>
                    <FormControl color="coopinfa" fullWidth>
                        <InputLabel id="categoria-label">Categoría</InputLabel>
                        <Select
                            labelId="categoria-label"
                            size="small"
                            value={categoria}
                            label="Categoría"
                            onChange={(event) => { setCategoria(event.target.value) }}
                        >
                            <MenuItem key={0} value={0}>{"(Todas)"}</MenuItem>
                            {
                                rowsCategorias.map((row) => {
                                    return <MenuItem key={row.id} value={row.id}>
                                        {row.texto}
                                    </MenuItem>
                                })
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={2} sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel
                        control={<Switch size="small" checked={incluyeInactivos}
                            color="coopinfa"
                            onChange={(event) => { setIncluyeInactivos(event.target.checked) }} />}
                        label="Incluir inactivos"
                    />
                </Grid>
            </Grid>
        </div>
        <div className={styles.catalogo}>
            {
                rows.map((row, index) => {
                    const f = JSON.parse(row.fotos)
                    const n = f.map((foto) => {
                        return {
                            previewUrl: rutaAzure + foto.url_thumbnail,
                            zoomUrl: rutaAzure + foto.url_zoom
                        }
                    })
                    return <div className={styles.items}>
                        <Item
                            key={index}
                            id={row.cual}
                            edit={handleEditItem}
                            mostrarEdit={true}
                            fotos={n}
                            descripcion={row.descripcion}
                            comentario={row.comentario}
                            precio={row.precio}
                            precioLista={row.precio_lista}
                        />
                    </div>
                }
                )
            }
        </div>
    </div>
}